import React, { FC } from 'react';

import styles from './cardGrayBannerStyles.scss';

const CardGrayBanner: FC<{ displayItems: { title: string; value?: string | null }[] }> = ({
  displayItems
}) => {
  return (
    <div className={styles.banner}>
      {displayItems.map((displayItem, idx) => (
        <div className={styles.displayItem} key={idx}>
          <label>{displayItem.title}</label>
          <span>{displayItem.value}</span>
        </div>
      ))}
    </div>
  );
};

export default CardGrayBanner;
